<div id="site-banner" class="site-banner">
    <div id="non-prd-banner" class="non-prd-banner" *ngIf="!isProduction">
        <strong>
            <span class="non-prd-banner-span">
                This is a non-production environment. If you are a patient, contact the system administrator immediately.&nbsp;
                <span title="Close this warning." (click)="closeBanner()" >[X]</span>
            </span>
        </strong>
    </div>
</div>
<router-outlet></router-outlet>